// Frontend mirror of backend isShortIdShape — used to detect short-id-shaped
// route segments before fetching. Keep in sync with backend/src/modules/shared/shortId.mjs.

export const SHORT_ID_ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789'
export const SHORT_ID_LENGTH = 6

const SHORT_ID_PATTERN = new RegExp(`^[${SHORT_ID_ALPHABET}]{${SHORT_ID_LENGTH}}$`)

export function isShortIdShape(value: unknown): value is string {
  return typeof value === 'string' && SHORT_ID_PATTERN.test(value)
}
